import styles from './styles.module.scss';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { FC, useState } from 'react';
import { WithChildren } from 'ts-types';

type Props = {
  isShow: boolean;
  setIsShow: (val: boolean) => void;
};
export const CollapseBtnComponent: FC<Props> = ({ isShow, setIsShow }) => {
  return (
    <button
      type="button"
      className={clsx(styles.hideBtn, !isShow ? styles.hiddenState : undefined)}
      onClick={() => setIsShow(!isShow)}
    >
      <InlineSvg path={'/media/icons/custom/up-square.svg'} className={styles.icon} />
    </button>
  );
};
